//CSS Import
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CardActions, Card, CardText } from 'react-md';
import { AppProperties, getDateFormat } from '../../../../common/functions';
import { Button, Divider, Grid, Snackbar, Typography } from '@mui/material';
import { isMobile } from 'react-device-detect';
import SFGoalDialog from './SFGoalDialog';
import SFGoalSlider from './SFGoalSlider';
import { BeatLoader } from 'react-spinners';
import LoadingSpinner from '../../../../components/LoadingSpinner';
import moment from 'moment';
import { AppContext } from '../../../../AppContext';


//bug-tracker#228 Line 11

//const SplashScreen = function(props) {
class SFSplashScreen extends Component {

    static contextType = AppContext;

    appProperties = AppProperties();

    constructor(props) {
        super(props);

        this.QuizList = this.QuizList.bind(this);

        this.state = {
            showGoal: false,
            showSnackBar: false,
            snackBarMessage: "",
            categoriesData: [],
            loading: false,
        }
    }

    componentDidMount() {
        if (this.props.quizID) {
            this.setState({
                loading: true
            })
            // get all the categories by quiz id with course
            this.props.apiService({
                method: 'post',
                url: '/getCategoriesByQuizID',
                data: {
                    quizID: this.props.quizID,
                    practiceCount: this.props.practiceCount,
                }
            }).then(res => {
                console.log("response>>>", res.data);
                if (res && res.data && res.data) {

                    this.setState({
                        categoriesData: res.data.category_names
                    })
                }
            }).catch(err => console.log("errr", err))
                .finally(() => {
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    QuizList() {
        //window.location.reload();
        //window.location.href = "/quizes";
        console.log("Close");
        this.props.history.push("/");

    }

    handleGoalChangeForQuiz = (type, newGoal) => {
        let updatedCategoriesData = this.state.categoriesData.map((cat) => {
            if (type === "accuracy") {
                return {
                    ...cat,
                    accuracyGoal: newGoal,
                }
            } else {
                return {
                    ...cat,
                    timeGoal: newGoal,
                }
            }

        })
        let payload = {
            quizID: this.props.quizID,
            practiceCount: this.props.practiceCount,
            isAccuracy: type === "accuracy",
            isTime: type === "time",
            categoryGoals: this.state.categoriesData.map(cat => {
                return {
                    catKey: `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`,
                    quizID: this.props.quizID,
                    isAccuracy: true,
                    accuracyGoal: type === "accuracy" ? newGoal : 0,
                    timeGoal: type === "time" ? newGoal : 0,
                }
            })
        }

        this.setGoal(payload);

        this.setState({
            categoriesData: updatedCategoriesData,
        })
    }

    handleSaveGoalForCategories = (updatedCategoriesData) => {
        this.setState({
            categoriesData: updatedCategoriesData,
        })
    }



    closeGoalDialog = () => {
        this.setState({
            showGoal: false,
        })
    }

    closeSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({
            showSnackBar: false,
            snackBarMessage: "",
        })
    };

    stripPTagsAndCheckEmpty = (html) => {
        const strippedHtml = html.replace(/(<([^>]+)>)/ig, "").trim();
        // console.debug("strippedHtml", strippedHtml)
        return strippedHtml === "";
    }

    


    render() {

        if (this.state.loading) {
            return (
                <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
                    <BeatLoader color={'#bb0000'} loading={true} size={15} />
                    <Typography fontSize={14} color={"#333"} className='mt-2'>
                        Loading Splash Screen
                    </Typography>
                </div>
            )
        }

        let text =
            this.props.isTest === 1
                ?
                (this.props.testWindowEnded)
                    ?
                    "Sorry! The Test is Closed!"
                    :
                    //Test
                    (this.props.isTimerExpired == 1)
                        ?
                        "Sorry! The Test Timer has Expired!"
                        :
                        (this.props.hasCompleted == 1)
                            ?
                            "Congratulations! You have completed the test."
                            :
                            ""
                :
                //Quiz
                (this.props.quizWindowEnded)
                    ?
                    "Sorry! The Quiz is Closed!"
                    :
                    (this.props.hasCompleted == 1)
                        ?
                        "Congratulations! You have completed the quiz."
                        :
                        ""
            ;

        if (this.props.invalidQuiz) {
            text = "Please start this assignment in Carmen";
        }
        if (this.props.quizNotPublished) {
            text = "This quiz is not yet published. Please ask your instructor to publish."
        }

        return (text !== "")
            ?

            <div className='splashScreencontainer'>
                <Card className="md-block-centered splashScreencontainer-card">
                    <CardText style={{ fontSize: '2rem' }}>
                        <center><Typography>
                            {text}
                            <br /></Typography></center>
                    </CardText>
                    <CardActions centered>
                        {this.props.invalidQuiz && this.props.carmenAssignmentLink ?
                            <Button variant='contained' style={{ color: '#fff' }} target='_blank' href={this.props.carmenAssignmentLink} primary>Take me to Carmen</Button> : null
                        }
                        {this.props.ltiUserID ? null :
                            <Button flat primary swapTheming onClick={this.QuizList}>Home</Button>
                        }
                    </CardActions>
                </Card>
            </div>
            :
            <div className='h-100 w-100 position-relative bg-white'>

                {!this.props.allowPractice ? (
                    <div className='practice-message-container'>
                        <div className='py-4' style={{ color: "#bb0000", textAlign: "center" }}>
                            {this.props.ltiPracticeMessage ? this.props.ltiPracticeMessage : "Sorry, this quiz is currently unavailable for practice. Please request the instructor to enable practice mode for this quiz."}
                        </div>
                    </div>
                )
                    :
                    <>
                        <div className='sf-splash-screen-container'>
                            {this.state.showGoal ?
                                <SFGoalDialog
                                    categoriesData={this.state.categoriesData}
                                    handleClose={this.closeGoalDialog}
                                    quizID={this.props.quizID}
                                    handleSaveGoalForCategories={this.handleSaveGoalForCategories}
                                    practiceCount={this.props.practiceCount}
                                />
                                : null}
                            <div className='sf-splash-screen-main'>
                                <div className='sf-splash-screen-left-content'>
                                    <Typography className='mb-4' fontSize={32} fontWeight={'600'} color={'primary'} textAlign={'center'}>WELCOME {this.appProperties.currentUserData.isAnonymous ? "" : `${this.props.globalProperties.currentUserData.GivenName}!`}</Typography>
                                    <div>
                                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>ASSIGNMENT NAME:</Typography>
                                        <Typography sx={{ fontWeight: '600', fontSize: 20 }} color={'primary'}>{this.props.title}</Typography>
                                    </div>
                                    <div className='mt-4'>
                                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>ASSIGNMENT TYPE:</Typography>
                                        <Typography sx={{ fontWeight: '600', fontSize: 20 }} color={'primary'}>{this.props.isTest === 0 ? "Mastery " : "Test"}
                                            {this.props.practiceCount > 0 ? " (Practice)" : ""}
                                        </Typography>
                                    </div>
                                    {this.context.isSpecialCourse || this.appProperties.isLTIStudent || this.props.courseName === "null" ? "" :
                                        <div className='d-flex justify-content-start mt-4'>
                                            <div className='mr-4'>
                                                <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>OPEN:</Typography>
                                                <Typography sx={{ fontWeight: '600', fontSize: 20 }} color={'primary'}>
                                                    {getDateFormat(this.props.startDate, this.props.timeZone)}
                                                    {/* {this.props.startDate ? moment(this.props.startDate, 'DD/MM/YYYY').format('MM/DD/YYYY') : ''} */}

                                                </Typography>
                                            </div>
                                            <div>
                                                <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>CLOSE:</Typography>
                                                <Typography sx={{ fontWeight: '600', fontSize: 20 }} color={'primary'}>
                                                    {getDateFormat(this.props.dueDate, this.props.timeZone)}
                                                    {/* {this.props.dueDate ? moment(this.props.dueDate, 'DD/MM/YYYY').format('MM/DD/YYYY') : ''} */}
                                                </Typography>
                                            </div>
                                        </div>
                                    }
                                    {/* {this.props.courseName && this.props.courseName !== "null" ?
                                        <div className='mt-4'>
                                            <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>COURSE NAME:</Typography>
                                            <Typography sx={{ fontWeight: '600', fontSize: 20 }} color={'primary'}>{this.props.courseName}</Typography>
                                        </div>
                                        : ""} */}
                                    <div className='mt-4'>
                                        <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>CATEGORIES IN ASSIGNMENT:
                                            {/* ({this.state.categoriesData?.length}) */}
                                        </Typography>
                                        <ul className='m-0 pl-4 fontClass-16 mt-2' style={{ gap: '1rem' }}>
                                            {this.state.categoriesData?.map((cat, index) => {
                                                return (
                                                    <li key={index}>{cat.category_label ? cat.category_label : cat.category_name}</li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                    {/*  {(this.props.isTest === 0 || isNaN(this.props.isTest)) && this.props.practiceCount > 0 ?
                                        <div className='mt-4 mb-3'>
                                            <Typography fontSize={14} className='mb-1' fontWeight={'700'}>SET A GOAL FOR THE ASSIGNMENT:</Typography>
                                            <Typography className='mb-2'>
                                            Your instructor wants you to set a goal for each of the categories in this assignment. Please click the below button to continue
                                            </Typography>
                                            <Button 
                                            disabled={this.props.isLockedOut}
                                            variant='contained' color='primary' onClick={() => {
                                                this.setState({
                                                    showGoal: true,
                                                })
                                            }}>Set Goals</Button>
                                        </div>
                                        : null} */}
                                </div>
                                <div className='sf-splash-screen-divider'></div>
                                <div className='sf-splash-screen-right-content'>
                                    <Typography variant='h6'>
                                        Instructions from your Instructor:
                                    </Typography>
                                    {this.stripPTagsAndCheckEmpty(this.props.splashText) ?
                                        <>
                                            <Typography variant="subtitle1">
                                                <em>
                                                    At the moment your instructor has not given any specific instructions on how to work this assignment
                                                </em>
                                            </Typography></>
                                        :
                                        <div className='sf-splash-screen-text' dangerouslySetInnerHTML={{ __html: this.props.splashText }} />
                                    }
                                </div>
                            </div>

                            <div className='d-flex justify-content-center align-items-center my-4' style={{ gap: '16px' }}>
                                {this.state.categoriesData === null || this.state.categoriesData === undefined || this.state.categoriesData?.length === 0 ? "No categories present in the quiz. Please contact your instructor" : 
                                <Button
                                    disabled={this.props.isLockedOut}
                                    variant='contained'
                                    onClick={() => this.props.onShowCategorySelection()}
                                >
                                    {this.props.isLockedOut ? "Locked" : "Start Assignment"}
                                </Button>
                                }
                            </div>
                            {this.props.isLockedOut ? <center><div style={{ color: 'grey', marginBottom: '20px' }}><b>Note :</b> You've attempted too many times. Your assignment is now locked! Please contact your teacher.</div></center> : null}
                        </div>


                        {/*  <div className='w-100 h-100 flex-column justify-content-center align-items-center d-none'>
                            <div className='w-100 bg-white d-flex justify-content-center align-items-center'>
                                <Grid container justifyContent='center'>

                                    <Grid item md={4} xs={12} className='sf-splash-screen-welcom-grid' style={{
                                        height: 'fit-content'
                                    }}>
                                        <div className='px-5'>
                                            <Typography className='sf-splash-screen-welcome-text'>WELCOME {this.props.globalProperties.currentUserData.GivenName}!</Typography>
                                            <div>
                                                <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>ASSIGNMENT NAME:</Typography>
                                                <Typography sx={{ fontWeight: '600', fontSize: 20 }} color={'primary'}>{this.props.title}</Typography>
                                            </div>
                                            {this.props.courseName && this.props.courseName !== "null" ?
                                                <div className='mt-4'>
                                                    <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>COURSE NAME:</Typography>
                                                    <Typography sx={{ fontWeight: '600', fontSize: 20 }} color={'primary'}>{this.props.courseName}</Typography>
                                                </div>
                                                : ""}
                                            <div className='mt-4'>
                                                <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>CATEGORIES IN ASSIGNMENT:({this.state.categoriesData?.length})</Typography>
                                                <ul className='m-0 pl-4 fontClass-16 mt-2' style={{ gap: '1rem' }}>
                                                    {this.state.categoriesData?.map((cat, index) => {
                                                        return (
                                                            <li key={index}>{cat.category_label ? cat.category_label : cat.category_name}</li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item md={4} xs={10} className='sf-splash-screen-grid' justifyContent='flex-start'>
                                        <div className='sf-splash-screen-divider'></div>
                                        <div className='sf-splash-screen-text' dangerouslySetInnerHTML={{ __html: this.props.splashText }} />
                                    </Grid>
                                </Grid>
                            </div>
                            <div className='d-flex justify-content-center align-items-center my-4' style={{ gap: '16px' }}>
                                <Button
                                    disabled={this.props.isLockedOut}
                                    variant='contained'
                                    onClick={() => this.props.onShowCategorySelection()}
                                >
                                    {this.props.isLockedOut ? "Locked" : "Start Assignment"}
                                </Button>
                            </div>
                            {this.props.isLockedOut ? <center><div style={{ color: 'grey', marginBottom: '20px' }}><b>Note :</b> You've attempted too many times. Your assignment is now locked! Please contact your teacher.</div></center> : null}
                        </div> */}
                    </>
                }
            </div>
    }
};

SFSplashScreen.propTypes = {
    title: PropTypes.string.isRequired,
    splashText: PropTypes.string,
};

export default SFSplashScreen;